import { Localization } from "../../../common/localizable-component";
import { FileUploadLocalization } from "./file-upload-types";

export const FILE_UPLOAD_LOCALIZATION: Localization<FileUploadLocalization> = {
  en: {
    required: "Please select one or more files to upload",
    fileError: "Wrong file format",
    single: {
      selectFileLabel: "Please drag and drop file to upload ",
      selectFileLabelSeparator: "or ",
      selectFileLabelMobile: "Please select file to upload",
      browseLinkLabel: "browse",
      browseFileLabel: "Browse files",
      addMoreLabel: "Add more",
      uploadLabel: "Upload file",
      cancelUploadLabel: "Cancel upload",
      uploadedStatus: "uploaded",
      stopUploadLabel: "Stop upload",
      uploadSuccessfulString: "file uploaded successfully",
      uploadFailedString: "file failed to upload",
      newUploadLabel: "New upload",
      wrongFileSize: "File size limit is {0} MB. Please upload smaller file.",
      wrongUploadSize:
        "Maximum upload size {0} MB was reached. Please remove some files to reactivate upload functionality."
    },
    multiple: {
      selectFileLabel: "Please drag and drop files to upload ",
      selectFileLabelSeparator: "or ",
      selectFileLabelMobile: "Please select files to upload",
      browseLinkLabel: "browse",
      browseFileLabel: "Browse files",
      addMoreLabel: "Add more",
      uploadLabel: "Upload files",
      cancelUploadLabel: "Cancel upload",
      uploadedStatus: "uploaded",
      stopUploadLabel: "Stop upload",
      uploadSuccessfulString: "{0} files uploaded successfully",
      uploadFailedString: "{0} files failed to upload",
      newUploadLabel: "New upload",
      wrongFileSize: "File size limit is {0} MB. Please upload smaller files.",
      wrongUploadSize:
        "Maximum upload size {0} MB was reached. Please remove some files to reactivate upload functionality."
    }
  },
  de: {
    required: "Bitte wählen Sie eine oder mehrere Dateien zum Hochladen aus",
    fileError: "falsches Datei Format",
    single: {
      selectFileLabel: "Bitte ziehen Sie eine Datei hinein ",
      selectFileLabelSeparator: "oder ",
      selectFileLabelMobile: "Bitte wählen Sie eine Datei aus",
      browseLinkLabel: "wählen Sie eine aus",
      browseFileLabel: "Datei auswählen",
      addMoreLabel: "Dateien hinzufügen",
      uploadLabel: "Hochladen",
      cancelUploadLabel: "Hochladen abbrechen",
      uploadedStatus: "hochgeladen",
      stopUploadLabel: "Hochladen abbrechen",
      uploadSuccessfulString: "Datei erfolgreich hochgeladen",
      uploadFailedString: "Fehler beim Hochladen der Datei",
      newUploadLabel: "Neue Datei auswählen",
      wrongFileSize: "Limit der Dateigröße ist {0} MB. Bitte kleinere Datei hochladen.",
      wrongUploadSize:
        "Maximales upload limit {0} MB wurde erreicht. Bitte entfernen Sie einige Dateien um den Upload zu reaktivieren."
    },
    multiple: {
      selectFileLabel: "Bitte ziehen Sie die Dateien hinein ",
      selectFileLabelSeparator: "oder ",
      selectFileLabelMobile: "Bitte wählen sie Dateien aus",
      browseLinkLabel: "wählen Sie welche aus",
      browseFileLabel: "Dateien auswählen",
      addMoreLabel: "Dateien hinzufügen",
      uploadLabel: "Hochladen",
      cancelUploadLabel: "Hochladen abbrechen",
      uploadedStatus: "hochgeladen",
      stopUploadLabel: "Hochladen abbrechen",
      uploadSuccessfulString: "{0} Dateien erfolgreich hochgeladen",
      uploadFailedString: "{0} Dateien konnten nicht hochgeladen werden",
      newUploadLabel: "Neue Dateien auswählen",
      wrongFileSize: "Limit der Dateigrößen ist {0} MB. Bitte kleinere Dateien hochladen.",
      wrongUploadSize:
        "Maximales Uploadlimit {0} MB wurde erreicht. Bitte entfernen Sie einige Dateien um den Upload zu reaktivieren."
    }
  },
  sv: {
    required: "Välj en eller flera filer att ladda upp",
    fileError: "Fel filformat",
    single: {
      selectFileLabel: "Dra och släpp filen du vill ladda upp",
      selectFileLabelSeparator: "eller",
      selectFileLabelMobile: "Välj en fil som du vill ladda upp",
      browseLinkLabel: "bläddra",
      browseFileLabel: "Bläddra bland filer",
      addMoreLabel: "Lägg till flera",
      uploadLabel: "Ladda upp fil",
      cancelUploadLabel: "Avbryt uppladdning",
      uploadedStatus: "laddats upp",
      stopUploadLabel: "Sluta ladda upp",
      uploadSuccessfulString: "filen laddades upp",
      uploadFailedString: "filen kunde inte laddas upp",
      newUploadLabel: "Ny uppladdning",
      wrongFileSize: "Gränsen för filstorlek är {0} MB. Vänligen ladda upp mindre fil.",
      wrongUploadSize:
        "Maximal uppladdningsstorlek {0} MB har uppnåtts. Ta bort några filer för att återaktivera uppladdningsfunktionen."
    },
    multiple: {
      selectFileLabel: "Dra och släpp filerna du vill ladda upp",
      selectFileLabelSeparator: "eller",
      selectFileLabelMobile: "Välj de filer som du vill ladda upp",
      browseLinkLabel: "bläddra",
      browseFileLabel: "Bläddra bland filer",
      addMoreLabel: "Lägg till flera",
      uploadLabel: "Ladda upp filer",
      cancelUploadLabel: "Avbryt uppladdning",
      uploadedStatus: "laddats upp",
      stopUploadLabel: "Sluta ladda upp",
      uploadSuccessfulString: "{0} filer laddades upp",
      uploadFailedString: "{0} misslyckades att laddas upp",
      newUploadLabel: "Ny uppladdning",
      wrongFileSize: "Gränsen för filstorlek är {0} MB. Vänligen ladda upp mindre filer.",
      wrongUploadSize:
        "Maximal uppladdningsstorlek {0} MB har uppnåtts. Ta bort några filer för att återaktivera uppladdningsfunktionen."
    }
  },
  nl: {
    required: "Selecteer één of meer bestanden om te uploaden",
    fileError: "Verkeerd bestandsformaat",
    single: {
      selectFileLabel: "Sleep een bestand om te uploaden ",
      selectFileLabelSeparator: "of ",
      selectFileLabelMobile: "Selecteer een bestand om te uploaden",
      browseLinkLabel: "kies er één uit",
      browseFileLabel: "Bestand kiezen",
      addMoreLabel: "Bestanden toevoegen",
      uploadLabel: "Upload",
      cancelUploadLabel: "Upload annuleren",
      uploadedStatus: "geüpload",
      stopUploadLabel: "Upload annuleren",
      uploadSuccessfulString: "Bestand met succes geüpload",
      uploadFailedString: "Fout bij het uploaden van het bestand",
      newUploadLabel: "Selecteer nieuw bestand",
      wrongFileSize: "De maximale bestandsgrootte is {0} MB. Upload kleinere bestand.",
      wrongUploadSize:
        "Maximale uploadgrootte {0} MB is bereikt. Verwijder enkele bestanden om de uploadfunctie opnieuw te activeren."
    },
    multiple: {
      selectFileLabel: "Sleep de bestanden om te uploaden ",
      selectFileLabelSeparator: "of ",
      selectFileLabelMobile: "Selecteer bestanden",
      browseLinkLabel: "kies er één uit",
      browseFileLabel: "Bestand kiezen",
      addMoreLabel: "Bestanden toevoegen",
      uploadLabel: "Upload",
      cancelUploadLabel: "Upload annuleren",
      uploadedStatus: "geüpload",
      stopUploadLabel: "Upload annuleren",
      uploadSuccessfulString: "{0} Bestanden succesvol geupload",
      uploadFailedString: "{0} De bestanden konden niet worden geüpload.",
      newUploadLabel: "Selecteer nieuwe bestanden",
      wrongFileSize: "De maximale bestandsgrootte is {0} MB. Upload kleinere bestanden.",
      wrongUploadSize:
        "Maximale uploadgrootte {0} MB is bereikt. Verwijder enkele bestanden om de uploadfunctie opnieuw te activeren."
    }
  },
  it: {
    required: "Si prega di selezionare uno o più file da caricare",
    fileError: "Formato file errato",
    single: {
      selectFileLabel: "Trascina e rilascia il file da caricare",
      selectFileLabelSeparator: "o ",
      selectFileLabelMobile: "Seleziona il file da caricare",
      browseLinkLabel: "sfoglia",
      browseFileLabel: "Sfoglia file",
      addMoreLabel: "Aggiungi altri",
      uploadLabel: "Avvia caricamento",
      cancelUploadLabel: "Rimuovi",
      uploadedStatus: "caricato",
      stopUploadLabel: "Annulla caricamento",
      uploadSuccessfulString: "file caricato con successo",
      uploadFailedString: "caricamento del file non riuscito",
      newUploadLabel: "Nuovo caricamento",
      wrongFileSize: "Il limite di dimensione dei file è di {0} MB. Carica un file più piccolo.",
      wrongUploadSize: "È stata raggiunta la dimensione massima di caricamento di {0} MB."
    },
    multiple: {
      selectFileLabel: "Trascina e rilascia uno o più file da caricare",
      selectFileLabelSeparator: "o ",
      selectFileLabelMobile: "Seleziona uno o più file da caricare",
      browseLinkLabel: "sfoglia",
      browseFileLabel: "Sfoglia file",
      addMoreLabel: "Aggiungi altri",
      uploadLabel: "Avvia caricamento",
      cancelUploadLabel: "Rimuovi",
      uploadedStatus: "caricato",
      stopUploadLabel: "Annulla caricamento",
      uploadSuccessfulString: "{0} file caricati con successo",
      uploadFailedString: "{0} caricamenti non riusciti",
      newUploadLabel: "Nuovo caricamento",
      wrongFileSize: "Il limite di dimensione dei file è di {0} MB. Carica dei file più piccoli.",
      wrongUploadSize:
        "È stata raggiunta la dimensione massima di caricamento di {0} MB. Rimuovi alcuni file per riattivare la funzionalità di caricamento."
    }
  },
  hu: {
    required: "Kérjük, válasszon egy vagy több fájlt a feltöltéshez!",
    fileError: "A fájl formátuma nem megfelelő!",
    single: {
      selectFileLabel: "Húzza ide a fájlt a feltöltéshez!",
      selectFileLabelSeparator: "vagy",
      selectFileLabelMobile: "Kérjük, válassza ki a feltöltendő fájlt!",
      browseLinkLabel: "Fájl feltöltése a számítógépről",
      browseFileLabel: "Fájl feltöltése a számítógépről",
      addMoreLabel: "További fájl hozzáadása",
      uploadLabel: "Fájl feltöltése",
      cancelUploadLabel: "Feltöltés megszakítása",
      uploadedStatus: "Feltöltve",
      stopUploadLabel: "Feltöltés leállítása",
      uploadSuccessfulString: "A feltöltés sikerült.",
      uploadFailedString: "A feltöltés meghiúsult.",
      newUploadLabel: "Új feltöltés",
      wrongFileSize: "A fájl méretének korlátja {0} MB. Kérjük, töltsön fel kisebb fájl(ok)at.",
      wrongUploadSize:
        "Elérte a maximális feltöltési méret {0} MB-ot. Kérjük, távolítson el néhány fájlt a feltöltési funkció újraindításához."
    },
    multiple: {
      selectFileLabel: "Húzza ide a fájlokat a feltöltéshez!",
      selectFileLabelSeparator: "vagy",
      selectFileLabelMobile: "Kérjük, válassza ki a feltöltendő fájlokat!",
      browseLinkLabel: "Fájlok feltöltése a számítógépről",
      browseFileLabel: "Fájlok feltöltése a számítógépről",
      addMoreLabel: "További fájlok hozzáadása",
      uploadLabel: "Fájlok feltöltése",
      cancelUploadLabel: "Feltöltés megszakítása",
      uploadedStatus: "Feltöltve",
      stopUploadLabel: "Feltöltés leállítása",
      uploadSuccessfulString: "{0} db fájl feltöltése sikerült.",
      uploadFailedString: "{0} db fájl feltöltése meghiúsult.",
      newUploadLabel: "Új feltöltés",
      wrongFileSize: "A fájl méretének korlátja {0} MB. Kérjük, töltsön fel kisebb fájl(ok)at.",
      wrongUploadSize:
        "Elérte a maximális feltöltési méret {0} MB-ot. Kérjük, távolítson el néhány fájlt a feltöltési funkció újraindításához."
    }
  },
  da: {
    required: "Vælg venligst en eller flere filer til upload",
    fileError: "Forkert filformat",
    single: {
      selectFileLabel: "Træk og slip venligst filen for at uploade",
      selectFileLabelSeparator: "eller",
      selectFileLabelMobile: "Vælg venligst filen til upload",
      browseLinkLabel: "gennemse",
      browseFileLabel: "gennemse filer",
      addMoreLabel: "Tilføj flere",
      uploadLabel: "Upload fil",
      cancelUploadLabel: "Annuller upload",
      uploadedStatus: "uploadet",
      stopUploadLabel: "Stop upload",
      uploadSuccessfulString: "filen er uploadet",
      uploadFailedString: "filen kunne ikke uploades",
      newUploadLabel: "Ny upload",
      wrongFileSize: "Filstørrelsesgrænsen er {0} MB. Upload venligst mindre fil.",
      wrongUploadSize:
        "Maksimal uploadstørrelse {0} MB blev nået. Fjern venligst nogle filer for at genaktivere uploadfunktionen."
    },
    multiple: {
      selectFileLabel: "Træk og slip venligst filerne for at uploade",
      selectFileLabelSeparator: "eller",
      selectFileLabelMobile: "Vælg venligst filer til upload",
      browseLinkLabel: "gennemse",
      browseFileLabel: "gennemse filer",
      addMoreLabel: "Tilføj flere",
      uploadLabel: "Upload filer",
      cancelUploadLabel: "Annuller upload",
      uploadedStatus: "uploadet",
      stopUploadLabel: "Stop upload",
      uploadSuccessfulString: "{0} filerne er uploadet",
      uploadFailedString: "{0} filerne blev ikke uploadet",
      newUploadLabel: "Ny upload",
      wrongFileSize: "Filstørrelsesgrænsen er {0} MB. Upload venligst mindre filer.",
      wrongUploadSize:
        "Maksimal uploadstørrelse {0} MB blev nået. Fjern venligst nogle filer for at genaktivere uploadfunktionen."
    }
  },
  fr: {
    required: "Veuillez sélectionner un ou plusieurs fichiers à télécharger",
    fileError: "Format de fichier erroné",
    single: {
      selectFileLabel: "Veuillez glisser et déposer le fichier pour le télécharger",
      selectFileLabelSeparator: "ou",
      selectFileLabelMobile: "Veuillez sélectionner le fichier à télécharger",
      browseLinkLabel: "consultez",
      browseFileLabel: "Parcourir les fichiers",
      addMoreLabel: "Ajouter plus",
      uploadLabel: "Télécharger le fichier",
      cancelUploadLabel: "Annuler le téléchargement",
      uploadedStatus: "téléchargé",
      stopUploadLabel: "Arrêter le téléchargement",
      uploadSuccessfulString: "fichier téléchargé avec succès",
      uploadFailedString: "le téléchargement du fichier a échoué",
      newUploadLabel: "Nouveau téléchargement",
      wrongFileSize: "La taille maximale des fichiers est de {0} Mo. Veuillez télécharger des fichiers plus petits.",
      wrongUploadSize:
        "La taille maximale de téléchargement {0} Mo a été atteinte. Veuillez supprimer certains fichiers pour réactiver la fonctionnalité de téléchargement."
    },
    multiple: {
      selectFileLabel: "Veuillez glisser et déposer les fichiers pour les télécharger",
      selectFileLabelSeparator: "ou",
      selectFileLabelMobile: "Veuillez sélectionner les fichiers à télécharger",
      browseLinkLabel: "consultez",
      browseFileLabel: "Parcourir les fichiers",
      addMoreLabel: "Ajouter plus",
      uploadLabel: "Télécharger des fichiers",
      cancelUploadLabel: "Annuler le téléchargement",
      uploadedStatus: "téléchargé",
      stopUploadLabel: "Arrêter le téléchargement",
      uploadSuccessfulString: "{0} fichiers téléchargés avec succès",
      uploadFailedString: "Le téléchargement de {0} fichiers a échoué",
      newUploadLabel: "Nouveau téléchargement",
      wrongFileSize: "La taille maximale des fichiers est de {0} Mo. Veuillez télécharger des fichiers plus petits.",
      wrongUploadSize:
        "La taille maximale de téléchargement {0} Mo a été atteinte. Veuillez supprimer certains fichiers pour réactiver la fonctionnalité de téléchargement."
    }
  },
  es: {
    required: "Por favor, seleccione uno o más archivos para cargar",
    fileError: "Formato de fichero incorrecto",
    single: {
      selectFileLabel: "Arrastre y suelte el fichero para cargarlo",
      selectFileLabelSeparator: "o",
      selectFileLabelMobile: "Seleccione el fichero que desea cargar",
      browseLinkLabel: "busque en",
      browseFileLabel: "Buscar ficheros",
      addMoreLabel: "Añade más",
      uploadLabel: "Cargar fichero",
      cancelUploadLabel: "Cancelar carga",
      uploadedStatus: "cargado",
      stopUploadLabel: "Detener la carga",
      uploadSuccessfulString: "fichero cargado correctamente",
      uploadFailedString: "Error al cargar el fichero",
      newUploadLabel: "Nueva carga",
      wrongFileSize: "El límite de tamaño de los archivos es de {0} MB. Por favor, suba archivos más pequeños.",
      wrongUploadSize:
        "Se ha alcanzado el tamaño máximo de carga {0} MB. Por favor, elimine algunos archivos para reactivar la funcionalidad de carga."
    },
    multiple: {
      selectFileLabel: "Arrastre y suelte los ficheros para cargarlos",
      selectFileLabelSeparator: "o",
      selectFileLabelMobile: "Por favor, seleccione los ficheros que desea cargar",
      browseLinkLabel: "busque en",
      browseFileLabel: "Buscar ficheros",
      addMoreLabel: "Añade más",
      uploadLabel: "Cargar ficheros",
      cancelUploadLabel: "Cancelar carga",
      uploadedStatus: "cargado",
      stopUploadLabel: "Detener la carga",
      uploadSuccessfulString: "{0} ficheros cargados correctamente",
      uploadFailedString: "{0} ficheros no cargados",
      newUploadLabel: "Nueva carga",
      wrongFileSize: "El límite de tamaño de los archivos es de {0} MB. Por favor, suba archivos más pequeños.",
      wrongUploadSize:
        "Se ha alcanzado el tamaño máximo de carga {0} MB. Por favor, elimine algunos archivos para reactivar la funcionalidad de carga."
    }
  },
  pl: {
    required: "Proszę wybrać jeden lub więcej plików do przesłania",
    fileError: "Nieprawidłowy format pliku",
    single: {
      selectFileLabel: "Proszę przeciągnąć i upuścić plik, aby go przesłać",
      selectFileLabelSeparator: "lub",
      selectFileLabelMobile: "Proszę wybrać plik do przesłania",
      browseLinkLabel: "przeglądaj",
      browseFileLabel: "Przeglądaj pliki",
      addMoreLabel: "Dodaj więcej",
      uploadLabel: "Prześlij plik",
      cancelUploadLabel: "Anuluj przesyłanie",
      uploadedStatus: "przesłane",
      stopUploadLabel: "Zatrzymaj przesyłanie",
      uploadSuccessfulString: "plik został przesłany pomyślnie",
      uploadFailedString: "nie udało się przesłać pliku",
      newUploadLabel: "Nowy upload",
      wrongFileSize: "Limit rozmiaru pliku wynosi {0} MB. Prosimy o przesyłanie mniejszych plików.",
      wrongUploadSize:
        "Osiągnięto maksymalny rozmiar przesyłania {0} MB. Usuń niektóre pliki, aby ponownie aktywować funkcję przesyłania."
    },
    multiple: {
      selectFileLabel: "Proszę przeciągnąć i upuścić pliki, aby je przesłać",
      selectFileLabelSeparator: "lub",
      selectFileLabelMobile: "Proszę wybrać pliki do przesłania",
      browseLinkLabel: "przeglądaj",
      browseFileLabel: "Przeglądaj pliki",
      addMoreLabel: "Dodaj więcej",
      uploadLabel: "Prześlij pliki",
      cancelUploadLabel: "Anuluj przesyłanie",
      uploadedStatus: "przesłane",
      stopUploadLabel: "Zatrzymaj przesyłanie",
      uploadSuccessfulString: "{0} pliki przesłane pomyślnie",
      uploadFailedString: "Nie udało się przesłać {0} plików",
      newUploadLabel: "Nowy upload",
      wrongFileSize: "Limit rozmiaru pliku wynosi {0} MB. Prosimy o przesyłanie mniejszych plików.",
      wrongUploadSize:
        "Osiągnięto maksymalny rozmiar przesyłania {0} MB. Usuń niektóre pliki, aby ponownie aktywować funkcję przesyłania."
    }
  },
  ro: {
    required: "Vă rugăm să selectați unul sau mai multe fișiere pentru a le încărca",
    fileError: "Format de fișier greșit",
    single: {
      selectFileLabel: "Vă rugăm să trageți și să fixați fișierul pentru a-l încărca",
      selectFileLabelSeparator: "sau",
      selectFileLabelMobile: "Vă rugăm să selectați fișierul de încărcat",
      browseLinkLabel: "răsfoiți",
      browseFileLabel: "Răsfoiți fișierele",
      addMoreLabel: "Mai mult",
      uploadLabel: "Încărcați fișierul",
      cancelUploadLabel: "Anulează încărcarea",
      uploadedStatus: "încărcat",
      stopUploadLabel: "Opriți încărcarea",
      uploadSuccessfulString: "fișier încărcat cu succes",
      uploadFailedString: "fișierul nu a reușit să se încarce",
      newUploadLabel: "Încărcare nouă",
      wrongFileSize: "Limita de dimensiune a fișierului este de {0} MB. Vă rugăm să încărcați fișiere mai mici.",
      wrongUploadSize:
        "A fost atinsă dimensiunea maximă de încărcare {0} MB. Vă rugăm să eliminați unele fișiere pentru a reactiva funcționalitatea de încărcare."
    },
    multiple: {
      selectFileLabel: "Vă rugăm să trageți și să fixați fișierele pentru a le încărca",
      selectFileLabelSeparator: "sau",
      selectFileLabelMobile: "Vă rugăm să selectați fișierele pentru a le încărca",
      browseLinkLabel: "browse",
      browseFileLabel: "Browse fișiere",
      addMoreLabel: "Adăugați mai multe",
      uploadLabel: "Încărcați fișiere",
      cancelUploadLabel: "Anulați încărcarea",
      uploadedStatus: "lîncărcat",
      stopUploadLabel: "Opriți încărcarea",
      uploadSuccessfulString: "{0} fișiere încărcate cu succes",
      uploadFailedString: "{0} fișiere nu au reușit să fie încărcate",
      newUploadLabel: "Încărcare nouă",
      wrongFileSize: "Limita de dimensiune a fișierului este de {0} MB. Vă rugăm să încărcați fișiere mai mici.",
      wrongUploadSize:
        "A fost atinsă dimensiunea maximă de încărcare {0} MB. Vă rugăm să eliminați unele fișiere pentru a reactiva funcționalitatea de încărcare."
    }
  },
  hr: {
    required: "Odaberite jednu ili više datoteka za učitavanje",
    fileError: "Pogrešan format datoteke",
    single: {
      selectFileLabel: "Povucite i ispustite datoteku za prijenos",
      selectFileLabelSeparator: "ili ",
      selectFileLabelMobile: "Odaberite datoteku za učitavanje",
      browseLinkLabel: "pretražite",
      browseFileLabel: "Pregledajte datoteke",
      addMoreLabel: "Dodaj još",
      uploadLabel: "Učitaj datoteku",
      cancelUploadLabel: "Odustani od prijenosa",
      uploadedStatus: "učitano",
      stopUploadLabel: "Zaustavi prijenos",
      uploadSuccessfulString: "datoteka je uspješno učitana",
      uploadFailedString: "datoteka nije uspjela učitati",
      newUploadLabel: "Novo učitavanje",
      wrongFileSize: "Ograničenje veličine datoteke je {0} MB. Učitajte manje datoteke.",
      wrongUploadSize:
        "Dosegnuta je maksimalna veličina za prijenos od {0} MB. Uklonite neke datoteke kako biste ponovno aktivirali funkciju prijenosa."
    },
    multiple: {
      selectFileLabel: "Povucite i ispustite datoteke za prijenos",
      selectFileLabelSeparator: "ili ",
      selectFileLabelMobile: "Odaberite datoteke za učitavanje",
      browseLinkLabel: "Pretražite",
      browseFileLabel: "Pregledajte datoteke",
      addMoreLabel: "Dodaj još",
      uploadLabel: "Učitaj datoteke",
      cancelUploadLabel: "Odustani od prijenosa",
      uploadedStatus: "učitano",
      stopUploadLabel: "Zaustavi prijenos",
      uploadSuccessfulString: "Uspješno učitano {0} datoteka",
      uploadFailedString: "Nije uspjelo učitavanje {0} datoteka",
      newUploadLabel: "Novo učitavanje",
      wrongFileSize: "Ograničenje veličine datoteke je {0} MB. Učitajte manje datoteke.",
      wrongUploadSize:
        "Dosegnuta je maksimalna veličina za prijenos od {0} MB. Uklonite neke datoteke kako biste ponovno aktivirali funkciju prijenosa."
    }
  },
  cs: {
    required: "Vyberte jeden nebo více souborů, které chcete nahrát",
    fileError: "Špatný formát souboru",
    single: {
      selectFileLabel: "Přetáhněte prosím soubor k nahrání",
      selectFileLabelSeparator: "nebo",
      selectFileLabelMobile: "Prosím, vyberte soubor k nahrání",
      browseLinkLabel: "procházet",
      browseFileLabel: "Procházet soubory",
      addMoreLabel: "Přidat další",
      uploadLabel: "Nahrát soubor",
      cancelUploadLabel: "Zrušit nahrávání",
      uploadedStatus: "nahraný",
      stopUploadLabel: "Zastavit nahrávání",
      uploadSuccessfulString: "soubor byl úspěšně nahrán",
      uploadFailedString: "soubor se nepodařilo nahrát",
      newUploadLabel: "Nové nahrávání",
      wrongFileSize: "Limit velikosti souboru je {0} MB. Nahrajte prosím menší soubor(y).",
      wrongUploadSize:
        "Bylo dosaženo maximální velikosti nahrávání {0} MB. Odstraňte prosím některé soubory, aby se znovu aktivovala funkce nahrávání."
    },
    multiple: {
      selectFileLabel: "Přetáhněte prosím soubory k nahrání",
      selectFileLabelSeparator: "nebo",
      selectFileLabelMobile: "Vyberte prosím soubory k nahrání",
      browseLinkLabel: "procházet",
      browseFileLabel: "Procházet soubory",
      addMoreLabel: "Přidat další",
      uploadLabel: "Nahrát soubory",
      cancelUploadLabel: "Zrušit nahrávání",
      uploadedStatus: "Nahráno",
      stopUploadLabel: "Zastavit nahrávání",
      uploadSuccessfulString: "{0} soubory byly úspěšně nahrány",
      uploadFailedString: "{0} soubory se nepodařilo nahrát",
      newUploadLabel: "Nové nahrávání",
      wrongFileSize: "Limit velikosti souboru je {0} MB. Nahrajte prosím menší soubor(y).",
      wrongUploadSize:
        "Bylo dosaženo maximální velikosti nahrávání {0} MB. Odstraňte prosím některé soubory, aby se znovu aktivovala funkce nahrávání."
    }
  },
  sl: {
    required: "Izberite eno ali več datotek, ki jih želite naložiti",
    fileError: "Napačen format datoteke",
    single: {
      selectFileLabel: "Prosimo, povlecite in spustite datoteko za prenos",
      selectFileLabelSeparator: "ali",
      selectFileLabelMobile: "Prosimo, izberite datoteko za prenos",
      browseLinkLabel: "Brskanje po",
      browseFileLabel: "Brskajte po datotekah",
      addMoreLabel: "Dodaj več",
      uploadLabel: "Naložite datoteko",
      cancelUploadLabel: "Prekliči nalaganje",
      uploadedStatus: "naloženo",
      stopUploadLabel: "Ustavite nalaganje",
      uploadSuccessfulString: "datoteka je bila uspešno naložena",
      uploadFailedString: "datoteko ni uspelo naložiti",
      newUploadLabel: "Novo nalaganje",
      wrongFileSize: "Omejitev velikosti datoteke je {0} MB. Prosimo, da naložite manjšo(e) datoteko(e).",
      wrongUploadSize:
        "Dosežena je bila največja velikost prenosa {0} MB. Prosimo, odstranite nekaj datotek, da ponovno aktivirate funkcijo nalaganja."
    },
    multiple: {
      selectFileLabel: "Za nalaganje povlecite in spustite datoteke",
      selectFileLabelSeparator: "ali",
      selectFileLabelMobile: "Prosimo, izberite datoteke za nalaganje",
      browseLinkLabel: "Brskanje po",
      browseFileLabel: "Brskajte po datotekah",
      addMoreLabel: "Dodaj več",
      uploadLabel: "Naložite datoteke",
      cancelUploadLabel: "Prekliči nalaganje",
      uploadedStatus: "naloženo",
      stopUploadLabel: "Ustavite nalaganje",
      uploadSuccessfulString: "{0} datoteke so bile uspešno naložene",
      uploadFailedString: "{0} datotek ni uspelo naložiti",
      newUploadLabel: "Novo nalaganje",
      wrongFileSize: "Omejitev velikosti datoteke je {0} MB. Prosimo, da naložite manjšo(e) datoteko(e).",
      wrongUploadSize:
        "Dosežena je bila največja velikost prenosa {0} MB. Prosimo, odstranite nekaj datotek, da ponovno aktivirate funkcijo nalaganja."
    }
  }
};
